import * as _ from "lodash";
import * as React from "react";
import type { ActionEditProps, ActionPlugin, FeaturePlugin } from "~/components/Actions/pluginRegistry";
import pluginRegistry from "~/components/Actions/pluginRegistry";
import { FormSectionHeading } from "~/components/form/index";
interface FeatureReadOnlyPropsInternal extends ActionEditProps {
    enabledFeatures: string;
    openFeaturesElement?: JSX.Element;
    isNew: boolean;
    plugin: ActionPlugin;
    expandedByDefault: boolean;
}
type FeatureReadOnlyProps = FeatureReadOnlyPropsInternal;
interface FeatureReadOnlyState {
    plugins: FeaturePlugin[];
}
//eslint-disable-next-line react/no-unsafe
export default class FeatureReadOnly extends React.Component<FeatureReadOnlyProps, FeatureReadOnlyState> {
    constructor(props: FeatureReadOnlyProps) {
        super(props);
        this.state = {
            plugins: [],
        };
    }
    componentDidMount() {
        this.refreshPlugins(this.props.enabledFeatures);
    }
    UNSAFE_componentWillReceiveProps(newProps: FeatureReadOnlyProps) {
        if (newProps.enabledFeatures !== this.props.enabledFeatures) {
            this.refreshPlugins(newProps.enabledFeatures);
        }
    }
    render() {
        return (<div>
                {this.state.plugins.map((plugin) => {
                const DefaultSection = plugin.readOnly ? plugin.readOnly : plugin.edit;
                return (<div key={plugin.title}>
                            <FormSectionHeading title={plugin.title}/>
                            <DefaultSection key={"featurereadonly-" + plugin.featureName} plugin={this.props.plugin} projectId={this.props.projectId} gitRef={this.props.gitRef} localNames={this.props.localNames} properties={this.props.properties} packages={this.props.packages} setPackages={this.props.setPackages} doBusyTask={this.props.doBusyTask} setProperties={this.props.setProperties} getFieldError={this.props.getFieldError} errors={this.props.errors} expandedByDefault={this.props.expandedByDefault}/>
                        </div>);
            })}
            </div>);
    }
    private refreshPlugins(enabledFeatures: string) {
        const featureNames = (enabledFeatures || "").split(",");
        const allFeatures = pluginRegistry.getAllFeatures();
        const plugins = _.chain(allFeatures)
            .filter((feature) => featureNames.includes(feature.featureName))
            .sortBy((feature) => feature.priority)
            .value();
        this.setState({ plugins });
    }
    static displayName = "FeatureReadOnly";
}
